import React from 'react';
import { useTranslation } from 'react-i18next';
import TurnAroundService from '@/services/turnarounds';
import DeleteConfirmationModal from '../common/modals/DeleteConfirmationModal';

interface DeleteTurnAroundConfirmProps {
  open: boolean;
  turnarounds: Array<{ id: string; name: string }>;
  onClose: () => void;
  onSuccess: (count: number) => void;
}

const DeleteTurnAroundConfirm: React.FC<DeleteTurnAroundConfirmProps> = ({
  open,
  turnarounds,
  onClose,
  onSuccess
}) => {
  const { t } = useTranslation();

  const handleDeleteConfirm = async (items: Array<{ id: string; name: string }>, accessToken: string, userId: string) => {
    const turnAroundService = new TurnAroundService();
    await Promise.all(
      items.map(turnaround =>
        turnAroundService.deleteTurnaround(turnaround.id)
      )
    );
  };

  return (
    <DeleteConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={handleDeleteConfirm}
      onSuccess={onSuccess}
      title={t('deleteTurnaroundTitle', 'Delete Turnaround')}
      items={turnarounds}
      itemType="turnaround"
    />
  );
};

export default DeleteTurnAroundConfirm;
